function normalizeGroupPart(value, fallback = "unknown") {
  const text = String(value || "").trim();
  return text || fallback;
}

function firstValue(...values) {
  return values.find((value) => String(value || "").trim());
}

export function getTimelineGroupIdentity(dayGroup = {}, index = 0) {
  const items = Array.isArray(dayGroup.items) ? dayGroup.items : [];
  const firstItem = items[0] || {};
  const day = firstValue(dayGroup.day, firstItem.day) || `unknown-${index}`;
  const channelType = firstValue(dayGroup.channel_type, firstItem.channel_type);
  const channelId = firstValue(
    dayGroup.channel_id,
    dayGroup.instance,
    dayGroup.channel_identifier,
    dayGroup.channel_display_number,
    dayGroup.channel_phone_number,
    firstItem.channel_id,
    firstItem.instance,
    firstItem.channel_identifier,
    firstItem.channel_display_number,
    firstItem.channel_phone_number,
  );

  return {
    channelId: normalizeGroupPart(channelId, "no-channel"),
    channelType: normalizeGroupPart(channelType, "unknown-channel"),
    day: normalizeGroupPart(day, `unknown-${index}`),
  };
}

export function getTimelineGroupKey(dayGroup = {}, index = 0) {
  const explicitKey = firstValue(
    dayGroup.group_key,
    dayGroup.timeline_group_key,
    dayGroup.channel_group_key,
  );
  const identity = getTimelineGroupIdentity(dayGroup, index);

  if (explicitKey) {
    return [
      explicitKey,
      identity.channelType,
      identity.channelId,
    ].join("|");
  }

  return [
    identity.day,
    identity.channelType,
    identity.channelId,
  ].join("|");
}

export function getTimelineGroupId(dayGroup = {}, index = 0) {
  const explicitId = firstValue(dayGroup.id);
  if (explicitId && !/^day-[^|]+$/.test(explicitId)) return explicitId;

  return `timeline-day-${getTimelineGroupKey(dayGroup, index)}`;
}
